import {createSelector} from "reselect";
import type {GlobalSportState} from "@atg-sport-shared/sportsbook-types-root";
import type {KamibClientState} from "../reducers/kambi.client.reducer";

const getKambiClientState = (
    state: GlobalSportState,
): KamibClientState | null | undefined => state.sportsbook?.kambiClient;

export const getIsKambiLoading: (arg0: GlobalSportState) => boolean = createSelector(
    getKambiClientState,
    (kambiClient) => Boolean(kambiClient?.isLoading),
);

export const getIsKambiDisposing: (arg0: GlobalSportState) => boolean = createSelector(
    getKambiClientState,
    (kambiClient) => Boolean(kambiClient?.isDisposing),
);

export const getIsWapiReady: (arg0: GlobalSportState) => boolean = createSelector(
    getKambiClientState,
    (kambiClient) => Boolean(kambiClient?.isWapiReady),
);

export const getHasKambiLoaded: (arg0: GlobalSportState) => boolean = createSelector(
    getKambiClientState,
    (kambiClient) => Boolean(kambiClient?.hasLoaded),
);
